import { render, staticRenderFns } from "./WebinarCalendar.vue?vue&type=template&id=84277f64&scoped=true"
import script from "./WebinarCalendar.vue?vue&type=script&lang=js"
export * from "./WebinarCalendar.vue?vue&type=script&lang=js"
import style0 from "./WebinarCalendar.vue?vue&type=style&index=0&id=84277f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84277f64",
  null
  
)

export default component.exports